import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const cv = {
	// 获取简历列表
	getCvList: payload => {
		return api.get(proxyApi + '/v3/cvs', payload)
	},
	// 判断是否可以创建简历
	canCreateCv: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/can_create_cv`, token)
	},
	// 导入简历
	importCv: payload => {
		return api.post(proxyApi + '/v3/cvs/imports', payload)
	},
	// 已登录无简历显示推荐模板
	getRecommendTemplate: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/get_suggested_template_names`)
	},
	// 将简历设置为可编辑
	editableCv: payload => {
		return api.post(proxyApi + '/v3/editable_cvs', payload)
	},
	// 获取8个template cv
	getTemplateCv: () => {
		return api.get(proxyApi + `/v3/template_cvs`)
	},
	// 获取简历修改简历名称的label
	getCvNamePart: token => {
		return api.get(proxyApi + `/v3/cvs/${ token }/name_part_options`)
	},
	// 复制简历
	duplicateCv: payload => {
		return api.post(proxyApi + '/v3/duplicate_cvs', payload)
	},
	// 软删除简历
	deleteCv: token => {
		return api.delete(proxyApi + `/v3/cvs/${ token }`)
	},
	// 获取简历详情
	getCvDetail: token => {
		return api.get(proxyApi + `/v3/cvs/${ token }`)
	},
	// 更新简历详情
	updateCvDetail: (token, payload) => {
		return api.put(proxyApi + `/v3/cvs/${ token }`, payload)
	},
	// 更新简历信息（vip参数）
	updateVipCvDetail: (token, payload) => {
		return api.put(proxyApi + `/v3/cvs/${ token }/membership_cv`, payload)
	},
	// 创建简历
	createCvDetail: payload => {
		return api.post(proxyApi + '/v3/cvs', payload)
	},
	// 校验是否翻译有翻译简历
	verifyCanTransCv: (token, payload) => {
		return api.get(proxyApi + `/v3/cv_accounts/${ token }/can_trans_cv`, payload)
	},
	// 翻译简历
	translateCv: payload => {
		return api.post(proxyApi + `/v3/translate_cvs`, payload)
	},
	// 查询校徽
	searchSchoolLogos: (token, payload) => {
		return api.get(proxyApi + `/v3/cvs/${ token }/school_logo`, payload)
	},
	// 上传校徽
	updateSchoolLogo: (token, payload) => {
		return api.put(proxyApi + `/v3/cvs/${ token }/school_logo`, payload)
	},
	// 删除校徽
	deleteSchoolLogo: (token, payload) => {
		return api.delete(proxyApi + `/v3/cvs/${ token }/school_logo`, payload)
	},
	// 创建基本信息模块
	createProfileData: (token, payload) => {
		return api.post(proxyApi + `/v3/cvs/${ token }/profile`, payload)
	},
	// 更新基本信息
	updateProfileData: (token, payload) => {
		return api.put(proxyApi + `/v3/cvs/${ token }/profile`, payload)
	},
	// 更新基本信息(Vip数据)
	updateVipProfileData: (token, payload) => {
		return api.put(proxyApi + `/v3/cvs/${ token }/membership_profile`, payload)
	},
	// 获取基本信息内容
	getProfileData: (token, payload) => {
		return api.get(proxyApi + `/v3/cvs/${ token }/profile`, payload)
	},
	getProfileDataByShare: token => {
		return api.get(proxyApi + `/v3/cvs/${ token }/profile/share`)
	},
	// 创建教育模块信息
	createEduExperience: payload => {
		return api.post(proxyApi + `/v3/edus`, payload)
	},
	// 教育模块内容
	getEduExperience: payload => {
		return api.get(proxyApi + '/v3/edus', payload)
	},
	// 更新教育信息
	updateEduExperience: (id, payload) => {
		return api.put(proxyApi + `/v3/edus/${ id }`, payload)
	},
	// 校验教育模块是否被引用
	edusVerify: id => {
		return api.get(proxyApi + `/v3/import/edus/${ id }`)
	},
	// 删除教育
	deleteEdus: id => {
		return api.delete(proxyApi + `/v3/edus/${ id }`)
	},
	// 创建工作模块信息
	createWorkExperience: payload => {
		return api.post(proxyApi + `/v3/works`, payload)
	},
	// 获取工作模块内容
	getWorkExperience: payload => {
		return api.get(proxyApi + '/v3/works', payload)
	},
	// 更新工作信息
	updateWorkExperience: (id, payload) => {
		return api.put(proxyApi + `/v3/works/${ id }`, payload)
	},
	// 校验工作模块是否被引用
	worksVerify: id => {
		return api.get(proxyApi + `/v3/import/works/${ id }`)
	},
	// 删除工作模块
	deleteWorks: id => {
		return api.delete(proxyApi + `/v3/works/${ id }`)
	},
	// 创建活动模块信息
	createOrgExperience: payload => {
		return api.post(proxyApi + `/v3/orgs`, payload)
	},
	// 获取活动模块内容
	getOrgExperience: payload => {
		return api.get(proxyApi + '/v3/orgs', payload)
	},
	// 更新活动信息
	updateOrgExperience: (id, payload) => {
		return api.put(proxyApi + `/v3/orgs/${ id }`, payload)
	},
	// 校验活动模块是否被引用
	orgsVerify: id => {
		return api.get(proxyApi + `/v3/import/orgs/${ id }`)
	},
	// 删除活动模块
	deleteOrgs: id => {
		return api.delete(proxyApi + `/v3/orgs/${ id }`)
	},
	// 创建作品模块信息
	createOpuExperience: payload => {
		return api.post(proxyApi + `/v3/opus`, payload)
	},
	// 获取作品模块内容
	getOpuExperience: payload => {
		return api.get(proxyApi + '/v3/opus', payload)
	},
	// 更新作品信息
	updateOpuExperience: (id, payload) => {
		return api.put(proxyApi + `/v3/opus/${ id }`, payload)
	},
	// 校验作品模块是否被引用
	opusVerify: id => {
		return api.get(proxyApi + `/v3/import/opus/${ id }`)
	},
	// 删除作品模块
	deleteOpus: id => {
		return api.delete(proxyApi + `/v3/opus/${ id }`)
	},
	// 创建自定义模块
	createCustom: payload => {
		return api.post(proxyApi + `/v3/custom_sections`, payload)
	},
	// 创建自定义模块经历
	createCustomInfo: (id, payload) => {
		return api.post(proxyApi + `/v3/custom_sections/${ id }/infos`, payload)
	},
	// 更新自定义模块经历
	updateCustomInfo: (customId, infoId, payload) => {
		return api.put(proxyApi + `/v3/custom_sections/${ customId }/infos/${ infoId }`, payload)
	},
	// 通过ids获取自定义模块内容
	getCustomInfoByIds: (id, payload) => {
		return api.get(proxyApi + `/v3/custom_sections/${ id }/infos`, payload)
	},
	// 获取某个自定义模块下的所有经历
	getCustomInfoById: id => {
		return api.get(proxyApi + `/v3/custom_sections/${ id }`)
	},
	// 获取自定义模块内容
	getCustomExperience: payload => {
		return api.get(proxyApi + '/v3/custom_sections', payload)
	},
	// 判断自定义模块里面的经历有没有被引用
	customVerify: (customId, id) => {
		return api.get(proxyApi + `/v3/import/custom_sections/${ customId }/infos/${ id }`)
	},
	// 更新自定义模块的名称
	updateCustomTitle: (id, payload) => {
		return api.put(proxyApi + `/v3/custom_sections/${ id }`, payload)
	},
	// 删除自定义模块
	deleteCustom: customId => {
		return api.delete(proxyApi + `/v3/custom_sections/${ customId }`)
	},
	// 删除自定义模块经历
	deleteCustomInfo: (customId, infoId) => {
		return api.delete(proxyApi + `/v3/custom_sections/${ customId }/infos/${ infoId }`)
	},
	// 获取其他模块内容
	getExtrasExperience: payload => {
		return api.get(proxyApi + '/v3/extras', payload)
	},
	// 获取一份简历中其他模块的信息
	getExtraInfo: payload => {
		return api.get(proxyApi + '/v3/extra', payload)
	},
	// 创建其他模块
	createExtra: payload => {
		return api.post(proxyApi + '/v3/extras', payload)
	},
	// 更新other模块
	updateExtra: payload => {
		return api.put(proxyApi + '/v3/extras', payload)
	},
	// 删除extra
	deleteExtra: payload => {
		return api.delete(proxyApi + '/v3/extras', payload)
	},
	// 获取分享的简历信息
	getCvDetailByShare: token => {
		return api.get(proxyApi + `/v3/share_cvs/${ token }`)
	},
	// 分享简历的edus works orgs 自定义模块信息
	getEduInfoByShare: payload => {
		return api.get(proxyApi + `/v3/edus/share`, payload)
	},
	getWorkInfoByShare: payload => {
		return api.get(proxyApi + `/v3/works/share`, payload)
	},
	getOrgInfoByShare: payload => {
		return api.get(proxyApi + `/v3/orgs/share`, payload)
	},
	getOpuInfoByShare: payload => {
		return api.get(proxyApi + `/v3/opus/share`, payload)
	},
	getCustomInfoByShare: (id, payload) => {
		return api.get(proxyApi + `/v3/custom_sections/${ id }/share`, payload)
	},
	getExtrasInfoByShare: payload => {
		return api.get(proxyApi + '/v3/extras/share', payload)
	},
	// 校验其他模块有没有被简历引用
	verifyExtra: payload => {
		return api.get(proxyApi + '/v3/import/extra', payload)
	},
	// 获取动词，案例，小贴士
	getAssistInfo: payload => {
		return api.get(proxyApi + `/v3/cvs/faqs/submodule_all_items`, payload)
	},
	cvCheck: payload => {
		return api.post(proxyApi + '/v3/cv_checks', payload)
	},
	// 获取阿里oss的配置
	getOssConfig: payload => {
		return api.get(proxyApi + '/v3/file_upload_token', payload)
	},
	// 下载简历
	downloadCv: (token, payload) => {
		return api.get(proxyApi + `/v3/cvs/${ token }/download_url`, payload)
	},
  // 下载图片
  downloadCvImage: (token, payload) => {
		return api.get(proxyApi + `/v3/cvs/${ token }/img_download_url`, payload)
	},
	// 搜索案例
	searchExamples: payload => {
		return api.get(proxyApi + '/v3/cvs/faqs/examples', payload)
	},
	// 工作模块案例展示
	changeWorkExample: (token, payload) => {
		return api.get(proxyApi + `/v3/cvs/${ token }/work_examples`, payload)
	},
	// 自动排序
	autoSort: (token, payload) => {
		return api.post(proxyApi + `/v3/cvs/${ token }/auto_sort`, payload)
	},
	// 获取默认模块标题
	getCvSectionTitle: () => {
		return api.get(proxyApi + `/v3/section_titles`)
	},
	// 下载简历阻断推荐职位
	getJobByDownloadCv: payload => {
		return api.get(proxyApi + '/v3/jobs/temp_jobs', payload)
	},
	// 获取用户最近一段教育经历的毕业时间
	getLastEduTime: (cvAccountToken) => {
		return api.get(proxyApi + `/v3/cv_accounts/${cvAccountToken}/last_edu`)
	},
	// 微信订阅消息通知
	wechatSubscribe: (cvAccountToken, payload) => {
		return api.post(proxyApi + `/v3/cv_accounts/${cvAccountToken}/subscriptions`, payload)
	},
	// 判断是不是用户的第一份简历
	getIsFirstCv: (payload) => {
		return api.get(proxyApi + `/v3/first_cvs`, payload)
	},
	// 获取其他模块-技能 tag
	getCvProfessionSkills: (cv_token) => {
		return api.get(proxyApi + `/v3/cvs/${cv_token}/profession_skills`,)
	},
	// 同意邀约发送简历
	sendCvToHr: (permission_id, cv_token, payload) => {
		return api.post(proxyApi + `/v3/resume_hr_permissions/${permission_id}/cv_attach/${cv_token}`, payload)
	},
	// 获取问卷
	getQuestionnaire: () => {
		return api.get(proxyApi + `/v3/questionnaires`)
	},
	// 获取 会员权益信息
	getPrivilegeInfo: (cv_token) => {
		return api.get(proxyApi + `/v3/cv_accounts/${cv_token}/agreement_count`)
	},

	// 添加可信设备
	addTrustedDevices: (payload) => {
		return api.post(proxyApi + `/v3/auth/trusted_devices`, payload)
	},
	// 获取设备列表
	getCredibleEquipment: (payload) => {
		return api.get(proxyApi + `/v3/auth/trusted_devices`, payload)
	},
	// 删除设备
	deleteCredibleEquipment: (device_number) => {
		return api.delete(proxyApi + `/v3/auth/trusted_devices/${device_number}`, {})
	},
	// 批量删除可信设备
	batchDelCredibleEquipment: (payload) => {
		return api.delete(proxyApi + `/v3/auth/trusted_devices`, payload)
	},
	getCip: () => {
		return api.get(`${process.env.VUE_APP_ENV === 'prod' ? 'https://api.wondercv.com' : 'https://api.wondercv.cn'}/health/cip?format=json`)
	}
}

export default cv
